import FooterBottomBarLink from "./footer-bottom-bar-link/footer-bottom-bar-link-component";
import FooterBottomBarSecurityLink from "./footer-bottom-bar-security-link/footer-bottom-bar-security-link-component";

export const linkComponentTypes = {
  FooterBottomBarLink,
  FooterBottomBarSecurityLink
};

// [FooterBottomBarLink, FooterBottomBarSecurityLink].forEach(linkTypeComponent => {
//   linkComponentTypes[linkTypeComponent.toString()] = linkTypeComponent;
// });

// linkComponentTypes["FooterBottomBarLink"] = FooterBottomBarLink;
// linkComponentTypes["FooterBottomBarSecurityLink"] = FooterBottomBarSecurityLink;

export default linkComponentTypes;
